var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"BoxVideos"}},[_c('ul',_vm._l((_vm.boxes),function(item){return _c('li',[_c('a',{attrs:{"href":item.link,"target":"_blank"}},[_c('div',{staticClass:"img"},[_c('img',{staticClass:"image",attrs:{"src":item.image}})]),_c('div',{staticClass:"content"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(item.title))])])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }